import {adminHttpClient} from "../commons/adminHttpClient";

const deleteProgramAudit = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/ProgramAudits/Delete`, {
        data:{id : id}
    })
}

export default deleteProgramAudit;